import { createContext, useContext, useMemo, useState } from "react";
import es from "./es.json";
import en from "./en.json";
import es2 from "./es2.json";
import en2 from "./en2.json";

// Deep-merge two plain dict objects (used to combine split translation files
// without losing nested keys when both files define the same top-level section).
function dmerge(a, b) {
  const out = { ...a };
  for (const k of Object.keys(b || {})) {
    const av = a?.[k], bv = b[k];
    if (av && bv && typeof av === "object" && typeof bv === "object"
        && !Array.isArray(av) && !Array.isArray(bv)) {
      out[k] = dmerge(av, bv);
    } else {
      out[k] = bv;
    }
  }
  return out;
}

const DICTS = { es: dmerge(es, es2), en: dmerge(en, en2) };
const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("rp_lang") || "es");

  const value = useMemo(() => {
    const dict = DICTS[lang] || DICTS.es;
    const t = (key, vars) => {
      let node = dict;
      for (const part of key.split(".")) {
        node = node?.[part];
        if (node === undefined) return key;
      }
      let text = typeof node === "string" ? node : key;
      if (vars) {
        Object.entries(vars).forEach(([k, v]) => {
          text = text.replace(`{${k}}`, v);
        });
      }
      return text;
    };
    const setLang = (l) => {
      localStorage.setItem("rp_lang", l);
      setLangState(l);
    };
    return { lang, setLang, t };
  }, [lang]);

  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
